import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/views/Home'
import PageNotFound from '@/views/PageNotFound'
import CreatePO from '@/views/create-po/Index.vue'
import PayPO from '@/views/pay-po/Index.vue'
import UserGuide from '@/views/user-guide/Index.vue'
import TermsOfUse from '@/views/terms-of-use/Index.vue'
import ContactUs from '@/views/contact-us/Index.vue'
import Maintenance from '@/views/maintenance/Index.vue'
import store from '../store'
import EventBus from '@/EventBus'

Vue.use(Router)

function buildCountryRouter (countryCode, { payPO = true, createPO = true, common = true } = {}) {
  const createPORoute = (countryCode) => ({
    path: `/${countryCode}/create-po`,
    name: 'CreatePO',
    component: CreatePO,
    meta: {
      title: 'Create PO | ONE - e-Payment'
    },
    props: {
      countryCode
    }
  })

  const payPORoute = (countryCode) => ({
    path: `/${countryCode}/pay-po`,
    name: 'PayPO',
    component: PayPO,
    meta: {
      title: 'Pay PO | ONE - e-Payment'
    },
    props: {
      countryCode
    }
  })

  const commonPagesRoutes = (countryCode) => ([
    {
      path: `/${countryCode}/contact-us`,
      name: 'ContactUs',
      component: ContactUs,
      meta: {
        title: 'Contact Us | ONE - e-Payment'
      },
      props: {
        countryCode
      }
    },
    {
      path: `/${countryCode}/terms-of-use`,
      name: 'TermsOfUse',
      component: TermsOfUse,
      meta: {
        title: 'Terms of Use | ONE - e-Payment'
      },
      props: {
        countryCode
      }
    },
    {
      path: `/${countryCode}/user-guide`,
      name: 'UserGuide',
      component: UserGuide,
      meta: {
        title: 'User Guide | ONE - e-Payment'
      },
      props: {
        countryCode
      }
    },
    {
      path: `/${countryCode}`,
      name: 'Home',
      component: Home,
      meta: {
        title: 'Home | ONE - e-Payment'
      },
      props: {
        countryCode
      }
    }
  ])

  const routes = []

  if (createPO) {
    routes.push(createPORoute(countryCode))
  }

  if (payPO) {
    routes.push(payPORoute(countryCode))
  }

  if (common) {
    routes.push(...commonPagesRoutes(countryCode))
  }

  return routes
}

const router = new Router({
  routes: [
    {
      path: '/maintenance',
      name: 'Maintenance',
      component: Maintenance
    },
    ...buildCountryRouter('id'),
    ...buildCountryRouter('th', { createPO: true, payPO: false, common: true }),
    {
      path: '*',
      name: 'NotFound',
      meta: {
        title: 'Not Found | ONE - e-Payment'
      },
      component: PageNotFound
    }
  ],
  mode: 'history',
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})

router.beforeEach(async (to, from, next) => {
  const allInputs = document.querySelectorAll('div[data-form-container] input')
  const hasInputtedData = [...allInputs].some(item => item.value)
  const switchCountryModalStatus = store.getters['settings/getSwitchCountryModalStatus']
  const isReadOnlyMode = store.getters['purchaseOrder/getReadOnlyModeStatus']
  const isNavigatingToPayPO = to.name === 'PayPO'
  const isNavigatingFromPayPO = from.name === 'PayPO'
  const isNavigatingToPayPOFromViewDetailPage = isNavigatingToPayPO && isReadOnlyMode
  const isCreatingPayment = store.getters['purchaseOrder/getCreatePaymentItemStatus']

  if (!hasInputtedData || switchCountryModalStatus || isNavigatingToPayPOFromViewDetailPage || isCreatingPayment) return next(true)

  next(false)
  await store.dispatch('settings/toggleConfirmNavigationModal')
  await new Promise((resolve) => {
    EventBus.$on('confirm-navigation-modal:confirm', async () => {
      await store.dispatch('settings/toggleConfirmNavigationModal')
      resolve(true)

      if (isReadOnlyMode) {
        await store.dispatch('purchaseOrder/setReadOnlyMode', false)
      }

      if (isNavigatingFromPayPO) {
        await store.dispatch('application/resetPaymentGatewayMethod')
      }

      next(true)
    })

    EventBus.$on('confirm-navigation-modal:discard', async () => {
      await store.dispatch('settings/toggleConfirmNavigationModal')

      resolve(true)
    })
  }).then(() => {
    EventBus.$off('confirm-navigation-modal:discard')
    EventBus.$off('confirm-navigation-modal:confirm')
  })
})

export {
  router
}
